export default __webpack_public_path__ + "media/images/images/portfolio/width-1200/portfolio-2-b34cc7e3879135a74e01485234f0f30d.jpg";